import React from "react";
import ReactMapGL from "react-map-gl";
import { useViewport, useUpdateViewport, useMapboxRef, useMapStyle } from "..";
import "mapbox-gl/dist/mapbox-gl.css";
/**
 * Wraps [`react-map-gl`'s `InteractiveMap`](https://uber.github.io/react-map-gl/#/Documentation/api-reference/interactive-map)
 * with a custom context to enable an easy map manipulation API, Also sets the mapboxRef for use elsewhere in the app.
 * Other props are spread onto the original InteractiveMap component. Used when `deck.gl` is not required.
 */
export const WrappedInteractiveMap = ({ children, ...props }) => {
    const { viewport } = useViewport();
    const { setViewportInBounds } = useUpdateViewport();
    const [, set] = useMapboxRef();
    // get theme sensitive map style (revert to commaps if there is no theme present)
    const mapStyle = useMapStyle();
    return (React.createElement(ReactMapGL, Object.assign({ mapboxApiAccessToken: process.env.REACT_APP_MAPBOX_API_ACCESS_TOKEN ||
            process.env.STORYBOOK_MAPBOX_API_ACCESS_TOKEN, onLoad: ({ target: map }) => {
            set(map);
            map.on("style.load", () => {
                // force re-render when new basemap loads
                set(undefined);
                set(map);
            });
        }, 
        // ref={ref => ref && set(ref.getMap())}
        onViewportChange: (viewport) => setViewportInBounds(viewport), mapStyle: mapStyle }, viewport, props), children));
};
